import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { label: '新手入门', path: '/category/rumen' },
      { label: '内容创作', path: '/category/neirong' },
      { label: '运营技巧', path: '/category/yunying' },
      { label: '流量变现', path: '/category/bianxian' },
    ],
  },
  {
    title: '热门专题',
    links: [
      { label: '算法解析', path: '/category/suanfa' },
      { label: '企业号运营', path: '/category/qiye' },
      { label: '涨粉方法', path: '/article/zhangfen-miji-90tian' },
      { label: '变现攻略', path: '/article/bianxian-moshi-daibi' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
      { label: '口碑评价', path: '/about#reputation' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-flashlight-fill text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">抖ying指南</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              最全面的抖ying短视频平台运营指南，帮助创作者和品牌主掌握核心玩法，实现粉丝增长与商业变现。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors no-underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2025 抖ying指南. 保留所有权利.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors no-underline">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors no-underline">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors no-underline">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}